import React from "react";

import styles from "./Error.module.scss";
import Text from "../Text/Text";
import JobRecommendationCard, { JobRecommendationCardProps } from "../Cards/JobRecommendationCard";
import SquareButton from "../Buttons/SquareButton";

interface ErrorProps {
    recommendationCards?: JobRecommendationCardProps[]
}

const Error = (props: ErrorProps & React.HTMLProps<HTMLDivElement>) => {
    const { recommendationCards = [], ...restProps } = props;

    return (
        <div {...restProps} className={styles.error}>
            <div className={styles.errorMessage}>
                <Text
                    className={styles.errorH1}
                    htmlTag="h1"
                    textStyle="heading-1"
                >
                    Oops! We couldn&apos;t find this page.
                </Text>
                <Text className={styles.errorParagraph} htmlTag="p" textStyle="sans-serif-body">
                    Luckily, we have some suggestions of great jobs on our site!
                </Text>
                <SquareButton
                    href="/search?searchType=jobs&tm_source=error_page"
                    className={styles.errorCTA}
                    color="mint"
                >
                    Explore Jobs
                </SquareButton>
            </div>
            {!!recommendationCards.length && (
                <section className={styles.jobRecommendations}>
                    <Text className={styles.jobRecommendationsTitle} htmlTag="h3" textStyle="heading-3">
                        Jobs On The Muse
                    </Text>
                    <div className={styles.jobRecommendationCards}>
                        {recommendationCards.map((cardProps) => {
                            const { jobUrl } = cardProps;
                            return (
                                <JobRecommendationCard
                                    classes={{ jobRecommendationCard: styles.jobRecommendationCard }}
                                    key={jobUrl}
                                    {...cardProps}
                                />
                            );
                        })}
                    </div>

                </section>
            )}
        </div>
    );
};

export { Error as default };
export type { ErrorProps };
